import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IIndividualsDebts } from 'src/app/modules/interfaces/debts.interface';
export interface IIndividualDebtsState {
  check: boolean;
  typeDebt: string;
  contractValue: number;
  installmentValue: number;
  interestRate: string;
  interestRateChoose: string;
}

@Component({
  selector: 'app-forms',
  templateUrl: './forms.component.html',
  styleUrls: ['./forms.component.scss'],
})
export class FormsComponent implements OnInit {
  @Input() data: IIndividualsDebts;
  @Output() value: EventEmitter<IIndividualsDebts> =
    new EventEmitter<IIndividualsDebts>();

  constructor() {}

  ngOnInit(): void {
    this.dataLocal = { ...this.data };
  }

  dataLocal: IIndividualsDebts;

  typeDebtKey = this.getKey();
  contractValueKey = this.getKey();
  installmentValueKey = this.getKey();
  interestRateKey = this.getKey();
  interestRateChooseKey = this.getKey();

  getKey(): string {
    return 'componente_' + Math.random().toString(36).substring(7);
  }

  updateDataValue(value, property: string): void {
    this.dataLocal = {
      ...this.dataLocal,
      [property]: value,
    };
    this.value.emit(this.dataLocal);
  }
}
